<template>
  <div id="page-wrap" v-if="loggedIn">
    <PageHeader :activeLink="'home'"></PageHeader>
    <div class="container content-wrap">
      <div class="row">
        <div class="hidden-xs col-md-10 col-md-offset-1">
          <QuickLinks></QuickLinks>
        </div>
        <CreditPaused
          v-if="creditPaused"
          class="hidden-sm hidden-xs"
          :creditPauseMsg="creditPauseMsg"
        ></CreditPaused>
        <BalanceIndicator class="hidden-sm hidden-xs" v-else></BalanceIndicator>
        <section class="col-md-6 content-section col-xs-12">
          <TransactionsDetail></TransactionsDetail>
        </section>
      </div>
      <MobileNav :activeLink="'home'" class="visible-xs"></MobileNav>
    </div>
  </div>
</template>

<script>
import PageHeader from "./PageHeader/index";
import BalanceIndicator from "./BalanceIndicator/index";
import CreditPaused from "./CreditPaused/index";
import MobileNav from "./MobileNav/index";
import TransactionsDetail from "./TransactionsDetail/index";
import QuickLinks from "./QuickLinks/index";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TransactionDetail",
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "creditPauseMsg",
      "creditPaused",
      "activeTransaction",
      "loggedIn"
    ])
  },
  components: {
    PageHeader,
    BalanceIndicator,
    CreditPaused,
    MobileNav,
    TransactionsDetail,
    QuickLinks
  },
  mounted() {
    this.$store.dispatch("loadHome");
    this.$store.dispatch("getUser").then(response => {
      response.version === "epaylaterv2"
        ? this.$router.push({ name: "Dashboard" })
        : "";
    });
  }
};
</script>
<style scoped lang="scss">
@import "../assets/sass/variables";

.content-section {
  background-color: var(--white);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-top: -10px;
  overflow: hidden;
  padding: 0;
  @media screen and (min-width: $md) {
    border-radius: 10px;
    margin-top: 0;
    min-height: 650px;
  }
  @media screen and (min-width: $md) {
    border-radius: 0px;
    background: white;
  }
  @media screen and (max-width: $md) {
    margin-top: 0;
    margin-bottom: 40px;
  }

  header {
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    margin-bottom: 0px;
    background-color: var(--white);

    @media screen and (max-width: $md) {
      border-bottom: 0px;
      border-radius: 0px;
      background: transparent;
    }
    .counter {
      min-width: 24px;
      height: 24px;
      text-align: center;
      display: inline-block;
      background-color: #fd7f5b;
      color: var(--white);
      border-radius: 12px;
      padding: 0 7px;
      line-height: 24px;
    }

    h1 {
      font-size: 14px;
      display: inline-block;
      line-height: 80px;
      margin: 0 0 0 10px;
      letter-spacing: -0.2px;
      color: #718099;
    }

    .blue-btn-lg {
      width: 110px;
      height: 48px;
      border-radius: 50px;
      background-color: #377cfd;
      float: right;
      border: none;
      font-size: 16px;
      color: var(--white);
      margin: 16px 0;
    }
  }

  ul.vendor-list {
    li {
      min-height: 80px;
      background-color: var(--white);
      border-bottom: 1px solid #f1f2f3;

      .vendor-icon {
        margin: 16px 0;
      }

      .vendor-detail {
        margin: 22px 0;
        h2,
        p {
          margin: 0;
        }

        .site-name {
          font-size: 16px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: -0.3px;
          color: #4b5566;
        }
        .date {
          font-family: Overpass;
          font-size: 12px;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #718099;
          font-weight: normal;
          margin-left: 0px;
          strong {
            color: #4b5566;

            font-weight: 600;
          }
        }
        .payby {
        }
      }
      .vendor-bill {
        text-align: right;
        font-size: 16px;
        color: #4b5566;
      }

      &.credit-paused,
      &.upcoming-payment,
      &.transaction-overdue {
        background-color: rgba(244, 92, 95, 0.03);
        .date,
        .date strong,
        .vendor-bill {
          color: #f45c5f;
        }
      }
    }
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/TransactionDetail.vue